export const FEATURE_UPDATE_NOTIFICATION_TRANSLATIONS = {
  // ===== TITLE =====
  newUpdateAvailableTitle: $localize`:@@pwa.title.newUpdateAvailable:È arrivato un aggiornamento! 🛎️`,
  requiredUpdateAvailableTitle: $localize`:@@pwa.title.requiredUpdateAvailableTitle:Aggiornamento richiesto`,

  // ===== MESSAGE =====
  newVersionAvailableMessage: (newVersion: string) =>
    $localize`:@@pwa.message.newVersionAvailable:Il concierge ha preparato una nuova versione per te (v. ${newVersion}:newVersion:). Nessuna interruzione, basta ricaricare la pagina.`,
  noNewVersionAvailableMessage: $localize`:@@pwa.message.noNewVersionAvailable:Nessuna nuova versione disponibile`,
  appUpdatedMessage: $localize`:@@pwa.message.appUpdated:Applicazione aggiornata 🎉`,
  sessionOutdatedMessage: $localize`:@@pwa.message.sessionOutdated:Questa sessione utilizza una versione non più aggiornata dell'applicazione. Per passare alla nuova versione e continuare è necessario ricaricare la pagina.`,

  // ===== BUTTON =====
  reloadNowButton: $localize`:@@pwa.button.reloadNow:Ricarica ora`,
  reloadAndContinueButton: $localize`:@@pwa.button.reloadAndContinue:Ricarica e continua`,
};
